<div id="webvoucherDetail" class="webvoucherdetail-container ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader [hasContent]="true">

  </ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="webvoucherdetail-content">
      <div class="webvoucherdetail-content-wrapper">
        <div class="webvoucher-balance-container">
          <ng-container *ngIf="webvoucherBalanceViewModel.showBalance">
            <div>
              <h4>
                <span langkey="phUser_Credit"></span>{{": " + priceFormatter(webvoucherBalanceViewModel.balance)}}
              </h4>
            </div>
          </ng-container>
          <ng-container *ngIf="webvoucherBalanceViewModel.showDiscountBonus">
            <div>
              <h4>
                <span langkey="phUser_Discount"></span>{{": " + priceFormatter(webvoucherBalanceViewModel.discountBonus,
                false) + " %"}}
              </h4>
            </div>
          </ng-container>
          <ng-container *ngIf="webvoucherBalanceViewModel.showBalanceBonus">
            <div>
              <h4>
                <span langkey="phUser_InvitationAmount"></span>{{": " +
                priceFormatter(webvoucherBalanceViewModel.balanceBonus)}}
              </h4>
            </div>
          </ng-container>
        </div>
        <qr-code-display [qrData]="webVoucherNo" [trigger$]="qrCodeVisible$" [autoActivate]="false" [animate]="true">
        </qr-code-display>
        <div class="webvoucher-qrcode">
          <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-hypersoft-coupon"></div>
          <span>{{userWebvoucherViewModel.webvoucherNumber}}</span>
        </div>
        <ng-container *ngIf="!isOnline">
          <div class="webvoucher-date">
            <span langkey="phWebvoucherDetail_Date_Caption"></span> {{webvoucherBalanceViewModel.storageDate}}
          </div>
        </ng-container>
        <div class="ya-button-group-wrapper">
          <div class="ya-button-group-container">
            <div class="ya-button-container">
              <button mat-flat-button [ngClass]="'mat-flat-button ya-body-1'" (click)="refreshWebvoucher(true)">
                <span langkey="phWebvoucherDetail_Button_Refresh"></span>
              </button>
            </div>
            <div class="ya-button-container">
              <button mat-button [ngClass]="'mat-button ya-caption no-hover'" (click)="OpenWebVoucherModal()">
                <span langkey="phWebvoucherDetail_button_Title"></span>
              </button>
            </div>
            <div class="ya-button-container"
              *ngIf="webvoucherBalanceViewModel.isActive && webvoucherBalanceViewModel.walletReferenceId">
              <div class="wallet-buttons">
                <button mat-button
                  (click)="addToWallet(webvoucherBalanceViewModel.walletReferenceId, 'Voucher', 'Apple')">
                  <img src="assets/core/svg/add_to_apple_wallet.svg" alt="Add to Apple Wallet">
                </button>
                <button mat-button
                  (click)="addToWallet(webvoucherBalanceViewModel.walletReferenceId, 'Voucher', 'Google')">
                  <img src="assets/core/svg/add_to_google_wallet.svg" alt="Add to Google Wallet">
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>